import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { brandLogo } from '../../constants/brandAssets';
import { FaSearch } from "react-icons/fa";
import { IoNotifications, IoChatbubbleEllipsesOutline } from "react-icons/io5";
import { FaIdCard } from "react-icons/fa";
import { FaBars, FaTimes } from "react-icons/fa";
import axios from "axios";
import DefaultImage from "./others-profiles/default.webp";
import { getPrimaryUserImage, toAbsolute } from "../../utils/userImages";

import { LoginContext } from "../../context/LoginContext";
import { fetchPendingRequestCount, REQUESTS_CHANGED_EVENT } from "../../services/connectionRequests";
import { MESSAGES_CHANGED_EVENT, formatBadgeCount } from "../../utils/messageEvents";
// import { defaultTheme } from "react-select";


const Header = () => {
  const [formData, setFormData] = useState({
    lookingFor: '',
    minAge: '',
    maxAge: '',
    minHeight: '',
    religion: '',
    caste: ''
  });

  const { userData, userId, setIsPremium, logout } = useContext(LoginContext);
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
  const [upgrade, setUpgrade] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchId, setSearchId] = useState("");
  const [searchName, setSearchName] = useState("");
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const [unreadMessages, setUnreadMessages] = useState(0);
  const [pendingRequests, setPendingRequests] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    if (!userId) return undefined;
    const loadPendingRequests = () => {
      fetchPendingRequestCount(userId)
        .then((res) => setPendingRequests(res.response === 'success' ? Number(res.count) || 0 : 0))
        .catch(() => {});
    };
    loadPendingRequests();
    window.addEventListener(REQUESTS_CHANGED_EVENT, loadPendingRequests);
    return () => window.removeEventListener(REQUESTS_CHANGED_EVENT, loadPendingRequests);
  }, [userId]);


  const fetchIsMessage = () => {
    const payload = new FormData();
    payload.append("id", userId);
    payload.append("looking", userData.looking_for);
    payload.append("gender", userData.gender);
    payload.append("status", userData.status);
    payload.append("email", userData.email);

    axios.post(`${process.env.REACT_APP_API_BASE_URL}message_controller/messageUser`, payload)
      .then(response => {
        const counts = response.data?.response === 'success' && Array.isArray(response.data.msgCount)
          ? response.data.msgCount
          : [];
        setUnreadMessages(counts.reduce((sum, item) => sum + (Number(item.no_msg) || 0), 0));
      })
      .catch(error => {
        console.error("There was an error fetching data in header!", error);
      });


  }
  const viewPlan = () => {
    const payload = new FormData();
    payload.append("user_id", userId);
    payload.append("looking", userData.looking_for);
    payload.append("gender", userData.gender);
    payload.append("status", userData.status);
    payload.append("email", userData.email);

    axios.post(`${process.env.REACT_APP_API_PAYMENT_URL}user/checkpaidprofile`, payload)
      .then(response => {
        const active = Boolean(response.data?.status);
        setUpgrade(active);
        setIsPremium(active);
      })
      .catch(error => {
        console.error("There was an error fetching data in header!", error);
      });


  }



  useEffect(() => {
    viewPlan();
  }, []);

  useEffect(() => {
    if (!userId) return undefined;
    const refreshUnread = () => {
      if (!document.hidden) fetchIsMessage();
    };
    refreshUnread();
    const interval = setInterval(refreshUnread, 1000 * 60);
    window.addEventListener(MESSAGES_CHANGED_EVENT, refreshUnread);
    document.addEventListener('visibilitychange', refreshUnread);
    return () => {
      clearInterval(interval);
      window.removeEventListener(MESSAGES_CHANGED_EVENT, refreshUnread);
      document.removeEventListener('visibilitychange', refreshUnread);
    };
  }, [userId]);

  const unreadLabel = unreadMessages > 0
    ? `Messages, ${unreadMessages} unread`
    : 'Messages';

  const renderMessageIcon = () => (
    <Link to="/chat" className="msg-btn" aria-label={unreadLabel} title={unreadLabel}>
      <IoChatbubbleEllipsesOutline className="msg-btn__icon" />
      {unreadMessages > 0 && (
        <span className="msg-btn__badge" aria-hidden="true">{formatBadgeCount(unreadMessages)}</span>
      )}
    </Link>
  );



  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleLogout = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDropdownOpen(false);
    logout();
    navigate('/login/');
  };

  const goTo = (e, path) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDropdownOpen(false);
    if (!path) return;
    navigate(path);
  };

  const uid = userId != null ? String(userId) : '';
  const menuItems = [
    { label: 'Desired Profile', path: '/recently-joined-matches/' },
    { label: 'My Profile', path: uid ? `/view-profile/${uid}` : null },
    { label: 'Partner Profile', path: uid ? `/edit-partner/${uid}` : null },
    { label: 'Requests', path: '/requests', badge: pendingRequests },
    upgrade
      ? { label: 'Active Plan', path: uid ? `/plan/${uid}` : null, highlight: true }
      : { label: 'Upgrade', path: uid ? `/upgrade/${uid}` : null, highlight: true },
    { label: 'Logout', path: null, logout: true },
  ];

  const renderProfileMenu = () => (
    isDropdownOpen && (
      <div className="dropdown" onClick={(e) => e.stopPropagation()}>
        <ul>
          {menuItems.map((item) => {
            if (!item.logout && !item.path) return null;
            return (
              <li
                key={item.label}
                className={item.highlight ? 'bg-danger' : undefined}
              >
                {item.logout ? (
                  <a href="/login/" onClick={handleLogout}>Logout</a>
                ) : (
                  <Link
                    className={item.highlight ? 'text-white' : undefined}
                    to={item.path}
                    onClick={(e) => goTo(e, item.path)}
                  >
                    {item.label}
                    {item.badge > 0 && (
                      <span className="badge rounded-pill bg-danger ms-2" aria-label={`${item.badge} pending requests`}>{item.badge}</span>
                    )}
                  </Link>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    )
  );

  const handleAdvancedSearch = (e) => {
    e.preventDefault();
    if (searchName != "" && searchName != undefined) {
      setIsSearchModalOpen(false);
      navigate(`/search?name=${searchName}`);
    }

    // Here you would typically make an API call with the search criteria
  };

  const handleSimpleSearch = async () => {
    try {
      const response = await axios.post(process.env.REACT_APP_API_BASE_URL + "admin-mat/api/search.php", {
        searchId
      });
    } catch (error) {
      console.error("Search failed:", error);
    }
  };









  return (
    <header className="header">
      {/* Desktop Layout */}
      <div className="desktop-header">
        {/* Left: Logo */}
        <div className="logo">
          <Link to='/recently-joined-matches/'><img src={brandLogo} alt="Hindu Sanjog Logo" className="img-fluid" /></Link>
        </div>

        {/* Center: Search Section */}
        <div className="search-container">
          <p
            className="search-select w-50"
            onClick={() => setIsSearchModalOpen(true)}>

            Search By Name?
          </p>
          <p
            className="search-select w-50"
            onClick={() => navigate('/search-id')}>
            Search By ID?
          </p>



          {/* <div className="simple-search-container">
            <input
              type="text"
              className="search-input"
              placeholder="Search By ID"
              value={searchId}
              onChange={(e) => setSearchId(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleSimpleSearch()}
            />
            <button className="search-btn" onClick={handleSimpleSearch}>
              <FaSearch />
            </button>
          </div> */}

        </div>

        {/* Right: Blog + Icons + Profile */}
        <div className="header-right">
          {/* <span className="blog-link">Blog</span> */}

          <div className="icons">
            {renderMessageIcon()}
            {/* <Link to={`/notification`} className="icon notification"><IoNotifications /> <span className="dot" /></Link> */}
          </div>

          <div className="profile-container" onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
            <img src={getPrimaryUserImage(userData) || (userData.pp ? toAbsolute(userData.pp) : DefaultImage)} alt="User" className="profile-img" />
            <span className="arrow">▾</span>
            {pendingRequests > 0 && <span className="dot" title="Pending connection requests" />}
            {renderProfileMenu()}
          </div>
        </div>
      </div>

      {/* Mobile Layout */}
      <div className="mobile-header">
        <div className="mobile-header-top">
          <div className="logo">
            <Link to='/recently-joined-matches/'><img src={brandLogo} alt="Hindu Sanjog Logo" className="img-fluid" /></Link>
          </div>

          <button
            className="mobile-toggle"
            onClick={() => setIsMobileNavOpen(!isMobileNavOpen)}
          >
            {isMobileNavOpen ? <FaTimes /> : <FaBars style={{ color: "#e53d5c" }} />}
          </button>

          {renderMessageIcon()}

          <div className="profile-container" onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
            <img src={getPrimaryUserImage(userData) || (userData.pp ? toAbsolute(userData.pp) : DefaultImage)} alt="User" className="profile-img" />
            <span className="arrow">▾</span>
            {pendingRequests > 0 && <span className="dot" title="Pending connection requests" />}
            {renderProfileMenu()}
          </div>


        </div>

        <div className={`mobile-nav-content ${isMobileNavOpen ? 'show' : ''}`}>
          {/* Search Section */}
          <div className="mobile-search-container">
            {/* <div className="simple-search-container">
              <input
                type="text"
                className="search-input"
                placeholder="Search By ID"
                value={searchId}
                onChange={(e) => setSearchId(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleSimpleSearch()}
              /> 
              <button className="search-btn" onClick={handleSimpleSearch}>
                <FaSearch />
              </button>
            </div>*/}

            <div className="mobile-search-options">
              <button
                className="mobile-search-option" style={{ background: "#e53d5c", color: "white", fontWeight: "bold" }}
                onClick={() => setIsSearchModalOpen(true)}
              >
                Search By Name?
              </button>
              <Link to="/search-id"
                className="mobile-search-option" style={{ background: "#e53d5c", color: "white", fontWeight: "bold" }}
              >
                Search By ID?
              </Link>
            </div>
          </div>

          {/* Right: Blog + Icons + Profile */}
          {/* <div className="mobile-header-right">

          </div> */}
        </div>
      </div>

      {/* Advanced Search Modal */}
      {isSearchModalOpen && (
        <div className="popup-overlay" onClick={() => setIsSearchModalOpen(false)}>
          <div className="popup-form" onClick={(e) => e.stopPropagation()}>
            <h2>
              Search <span className="highlight">For Your Partner</span>
            </h2>
            <form onSubmit={handleAdvancedSearch}>
              <div className="form-group">
                <label>Enter Partner Name *</label>
                <input required={true} placeholder="Ex: Mona" className="form-control" type={'text'} value={searchName} onChange={(e) => setSearchName(e.target.value)} />
              </div>


              <button type="submit" className="search-btn search-btn-full mt-3">
                Search
              </button>

              <div className="divider">Or</div>

              <Link to="/search-id">
                <button type="button" className="search-id-btn mt-3">
                  <FaIdCard /> Search By ID
                </button>
              </Link>
            </form>
          </div>
        </div>
      )}

      <style jsx>{`
          .header {
            background: #FCECEF;
            border-bottom: 1px solid rgba(229, 61, 92, 0.15);
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            position: relative;
            z-index: 10;
          }

          /* Desktop Header */
          .desktop-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 15px 30px;
          }


          .search-container {
            display: flex;
            align-items: center;
            background: #f8f8f8;
            border-radius: 25px;
            padding: 5px 15px;
            flex: 0.6;
            border: 1px solid #e0e0e0;
          }

          .search-select {
            padding: 8px 12px;
            font-size: 14px;
            color: #555;
            cursor: pointer;
            margin: 0;
            font-weight: 500;
            border-right: 1px solid #e0e0e0;
            display: flex;
            align-items: center;
          }

          .search-select:last-child {
            border-right: none;
          }

          .simple-search-container {
            display: flex;
            flex: 1;
            align-items: center;
          }

          .search-input {
            flex: 1;
            border: none;
            padding: 8px 12px;
            font-size: 14px;
            outline: none;
            background: transparent;
          }

          .search-btn {
            background: #e53d5c;
            color: white;
            border: none;
            padding: 8px 15px;
            cursor: pointer;
            font-size: 14px;
            border-radius: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .header-right {
            display: flex;
            align-items: center;
            gap: 20px;
          }

          .blog-link {
            font-weight: 500;
            cursor: pointer;
            color: #555;
            font-size: 14px;
          }

          .icons {
            display: flex;
            align-items: center;
            gap: 15px;
          }

          .msg-btn {
            position: relative;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 42px;
            height: 42px;
            border-radius: 50%;
            background: #fff;
            color: #e53d5c;
            border: 1px solid rgba(229, 61, 92, 0.25);
            box-shadow: 0 2px 6px rgba(229, 61, 92, 0.12);
            text-decoration: none;
            flex-shrink: 0;
            transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
          }

          .msg-btn:hover,
          .msg-btn:focus-visible {
            background: #e53d5c;
            color: #fff;
            box-shadow: 0 4px 12px rgba(229, 61, 92, 0.3);
            transform: translateY(-1px);
          }

          .msg-btn:focus-visible {
            outline: 2px solid #e53d5c;
            outline-offset: 2px;
          }

          .msg-btn__icon {
            font-size: 22px;
          }

          .msg-btn__badge {
            position: absolute;
            top: -5px;
            right: -6px;
            min-width: 20px;
            height: 20px;
            padding: 0 5px;
            border-radius: 10px;
            background: #e53d5c;
            color: #fff;
            border: 2px solid #FCECEF;
            font-size: 11px;
            font-weight: 700;
            line-height: 16px;
            text-align: center;
            box-sizing: border-box;
            animation: msg-badge-pop 0.25s ease-out;
          }

          .msg-btn:hover .msg-btn__badge,
          .msg-btn:focus-visible .msg-btn__badge {
            background: #fff;
            color: #e53d5c;
            border-color: #e53d5c;
          }

          @keyframes msg-badge-pop {
            from { transform: scale(0.4); opacity: 0; }
            to { transform: scale(1); opacity: 1; }
          }

          @media (prefers-reduced-motion: reduce) {
            .msg-btn,
            .msg-btn__badge {
              transition: none;
              animation: none;
            }
          }

          .icon {
            position: relative;
            font-size: 20px;
            cursor: pointer;
            color: #555;
          }

          .dot {
            position: absolute;
            top: -3px;
            right: -3px;
            width: 8px;
            height: 8px;
            background: #e53d5c;
            border-radius: 50%;
          }

          .profile-container {
            display: flex;
            align-items: center;
            position: relative;
            cursor: pointer;
            gap: 6px;
            padding: 3px 10px 3px 3px;
            background: #fff;
            border: 1px solid rgba(229, 61, 92, 0.25);
            border-radius: 999px;
            box-shadow: 0 2px 6px rgba(229, 61, 92, 0.12);
            transition: box-shadow 0.2s ease;
          }

          .profile-container:hover {
            box-shadow: 0 4px 12px rgba(229, 61, 92, 0.25);
          }

          .profile-img {
            width: 34px;
            height: 34px;
            border-radius: 50%;
            object-fit: cover;
            border: 2px solid #e53d5c;
          }

          .arrow {
            color: #777;
            font-size: 12px;
          }

          .dropdown {
            position: absolute;
            top: 100%;
            right: 0;
            background: white;
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
            border-radius: 8px;
            padding: 8px 0;
            z-index: 1000;
            min-width: 150px;
          }

          .dropdown ul {
            list-style: none;
            padding: 0;
            margin: 0;
          }

          .dropdown li {
            padding: 0;
            cursor: pointer;
            font-size: 14px;
          }

          .dropdown li a,
          .dropdown li .text-white {
            display: block;
            padding: 8px 16px;
            text-decoration: none;
            color: inherit;
          }

          .dropdown li:hover {
            background: #f5f5f5;
            color: #e53d5c;
          }

          .dropdown li.bg-danger:hover {
            background: #c82333;
            color: #fff;
          }

          /* Mobile Header */
          .mobile-header {
            display: none;
            padding: 15px;
          }

          .mobile-header-top {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }

          .mobile-toggle {
            border: none;
            background: transparent;
            font-size: 1.5rem;
            color: #555;
            padding: 0.5rem;
          }

          .mobile-nav-content {
            max-height: 0;
            overflow: hidden;
            transition: max-height 0.3s ease-out;
          }

          .mobile-nav-content.show {
            max-height: 500px;
          }

          .mobile-search-container {
            margin-top: 15px;
          }

          .mobile-search-options {
            display: flex;
            gap: 10px;
            margin-top: 10px;
          }

          .mobile-search-option {
            flex: 1;
            padding: 10px;
            background: #f8f8f8;
            border: 1px solid #e0e0e0;
            border-radius: 20px;
            text-align: center;
            font-size: 14px;
            color: #555;
            cursor: pointer;
          }

          .mobile-header-right {
            margin-top: 20px;
            display: flex;
            flex-direction: column;
            gap: 15px;
          }

          .mobile-icons {
            display: flex;
            gap: 15px;
          }

          /* Modal Styles */
          .popup-overlay {
            position: fixed;
            inset: 0;
            background: rgba(0,0,0,0.5);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 9999;
            padding: 20px;
          }

          .popup-form {
            background: #fff;
            padding: 30px;
            border-radius: 12px;
            max-width: 600px;
            width: 100%;
            box-shadow: 0 4px 16px rgba(0,0,0,0.2);
            overflow-y: auto;
            max-height: 90vh;
          }

          .popup-form h2 {
            margin-bottom: 20px;
            font-size: 24px;
            text-align: center;
            color: #333;
          }

          .highlight {
            color: #e53d5c;
          }

          .form-group {
            margin-bottom: 15px;
          }

          .form-group label {
            display: block;
            margin-bottom: 5px;
            font-weight: 500;
            color: #555;
          }

          .form-group select {
            width: 100%;
            padding: 10px;
            border: 1px solid #ddd;
            border-radius: 6px;
            font-size: 14px;
            background: #f8f8f8;
          }

          .form-row {
            display: flex;
            gap: 10px;
          }

          .form-row .form-group {
            flex: 1;
          }

          .divider {
            display: flex;
            align-items: center;
            text-align: center;
            margin: 15px 0;
            color: #999;
            font-weight: bold;
          }

          .divider::before,
          .divider::after {
            content: "";
            flex: 1;
            border-bottom: 1px solid #eee;
            margin: 0 10px;
          }

          .search-btn-full {
            width: 100%;
            padding: 12px;
            font-size: 16px;
            border-radius: 6px;
          }

          .search-id-btn {
            width: 100%;
            background: #fff;
            border: 1px solid #e53d5c;
            color: #e53d5c;
            padding: 12px;
            font-size: 14px;
            border-radius: 6px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            transition: all 0.3s ease;
          }

          .search-id-btn:hover {
            background: #fdf2f4;
          }

          /* Responsive */
          @media (max-width: 992px) {
            .desktop-header {
              display: none;
            }
            .mobile-header {
              display: block;
            }
          }
        `}</style>
    </header>
  );
};

export default Header;